<template>
  <Dialog v-model="dialog" width="400">
    <template slot="title">
      <span class="_dialog-title">{{getTitle}}</span>
    </template>

    <template slot="content">
      <section class="pt-4 pb-5">
        <TextField v-model="name" :placeholder="placeholder" />
      </section>
    </template>

    <template slot="actions">
      <div class="d-flex justify-end" style="gap: 8px">
        <Button
          outlined
          label="Cancelar"
          text-color="bt_color"
          textSize="0.80rem"
          @click="handleCancel"
        />

        <Button 
          label="Confirmar" 
          :disabled="!name" 
          textSize="0.80rem" 
          @click="handleConfirm"
        />
      </div>
    </template>
  </Dialog>
</template>

<script>
import Dialog from "../../_v2/ui/Dialog.vue"
import TextField from "../../_v2/ui/TextField.vue"
import Button from "../../_v2/ui/Button.vue"

export default {
  name: 'RenameDialog',
  components: {Dialog, TextField, Button},
  props: {
    isOpen: {type: Boolean, required: true},
    type: {type: String, required: true}, // section or style
    placeholder: {type: String},
    objectToRename: {type: Object, required: false, default: null},
    objectKey: {type: String, required: true, default: null}
  },

  computed: {
    getTitle () {
      if (this.type === 'section') return 'Renomear seção'
      else return 'Renomear estilo'
    }
  },

  data: () => ({
    dialog: false,
    name: ''
  }),

  methods: {
    handleCancel () {
      this.name = ''
      this.dialog = false
    },

    handleConfirm () {
      this.objectToRename[this.objectKey] = this.name
      this.dialog = false
    }
  },

  watch: {
    isOpen (value) {
      if (value) {
        this.dialog = value
        this.name = this.objectToRename[this.objectKey]
      }
    },

    dialog (value) {
      if (!value) this.$emit('onClose')
    }
  },

  beforeDestroy () {
    if (process.env.NODE_ENV === "development" && this.isOpen) this.$emit('onClose')
  }
}
</script>